export const BRAND_NAME_KEY = 'brand.name'

export const BRAND_NAME_EN = 'HELPER CASINO'

export const LOGO_URL = '/assets/images/logo-casino.png'

export const SIDEBAR_TELEGRAM_BANNER = '/assets/images/telegram-inquiry_ko.png'

export const SIDEBAR_BRAND_BANNER = '/assets/images/1_6.png'

export const MAIN_NAV_ITEMS = [

  { key: 'home', labelKey: 'nav.home' },

  { key: 'live', labelKey: 'nav.live' },

  { key: 'slots', labelKey: 'nav.slots' },

  { key: 'sports', labelKey: 'nav.sports' },

  { key: 'minigames', labelKey: 'nav.minigames' },

  { key: 'fishing', labelKey: 'nav.fishing', fishingOnly: true }

]

export const MOBILE_NAV_ITEMS = [

  { icon: 'home', labelKey: 'nav.home', key: 'home' },

  { icon: 'live', labelKey: 'nav.live', key: 'live' },

  { icon: 'slots', labelKey: 'nav.slots', key: 'slots' },

  { icon: 'sports', labelKey: 'nav.sports', key: 'sports' },

  { icon: 'minigames', labelKey: 'nav.mini', key: 'minigames' },

  { icon: 'fishing', labelKey: 'nav.fishing', key: 'fishing', fishingOnly: true }

]

export const SIDE_MENU_ITEMS = [

  { icon: '◎', labelKey: 'nav.mypage', key: 'mypage' },

  { icon: '▱', labelKey: 'nav.deposit', key: 'deposit' },

  { icon: '▽', labelKey: 'nav.withdraw', key: 'withdraw' },

  { icon: '✦', labelKey: 'nav.event', key: 'event' },

  { icon: '▣', labelKey: 'nav.notice', key: 'notice' },

  { icon: '◉', labelKey: 'nav.support', key: 'support' },

  { icon: '✉', labelKey: 'nav.slip', key: 'slip' },

  { icon: '▤', labelKey: 'nav.betting', key: 'betting' }

]

export function isFishingUsageEnabled (fishingUsage) {
  return Number(fishingUsage) === 1
}

/** @deprecated filterGameNavItems 사용 */

export function filterNavByFishingUsage (items, fishingEnabled) {
  if (!Array.isArray(items)) return []

  return items.filter(item => !item.fishingOnly || fishingEnabled)
}

export const BLACK_GOLD_DATA = {

  sideMenu: SIDE_MENU_ITEMS,

  mobileNav: MOBILE_NAV_ITEMS,

  categories: [

    { icon: 'live', labelKey: 'nav.live', key: 'live' },

    { icon: 'slots', labelKey: 'games.slotsTitle', key: 'slots' },

    { icon: 'sports', labelKey: 'games.sportsTitle', key: 'sports' },

    { icon: 'hot', labelKey: 'games.hotTitle', key: 'hot' },

    { icon: 'jackpot', labelKey: 'jackpot.title', key: 'jackpot' },

    { icon: 'events', labelKey: 'nav.event', key: 'events' }

  ],

  games: [

    { title: 'Evolution 바카라', provider: 'Evolution', img: 'game-baccarat-hd.png' },

    { title: 'Evolution 블랙잭', provider: 'Evolution', img: 'game-blackjack-hd.png' },

    { title: 'Pragmatic Play 스위트 보난자', provider: 'Pragmatic Play', img: 'game-bonus-hd.png' },

    { title: 'PG 소 림 가든 보난자', provider: 'PG Soft', img: 'game-pg-hd.png' },

    { title: 'Habanero 바이킹 오브 토르', provider: 'Habanero', img: 'game-habanero-hd.png' }

  ],

  jackpotSeed: 4278593160,

  jackpotAmount: '₩ 1,234,567,890'

}

export function assetUrl (filename) {
  return `/assets/black-gold/${filename}`
}
